import React, { useEffect, useState } from "react";
import { RadioButton, SelectWithLabel } from "../../components/micro/input";
import ConfirmationModel from "../../components/common/ConfirmationModel";
import {
  addQuotation,
  getSalesList,
  getServiceById,
} from "../../redux/service/slice";
import { useDispatch, useSelector } from "react-redux";

const ExistingQuotationModal = ({ onClose, existingData }) => {
  const dispatch = useDispatch();
  const [selectedType, setSelectedType] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedOption, setSelectedOption] = useState("existingQuotation");
  const [showForm, setShowForm] = useState(true);
  const [error, setError] = useState("");

  const handleAddClick = () => {
    if (selectedOption === "existingQuotation" && !selectedType) {
      setError("Please select a system quotation.");
      return;
    }
    setShowForm(false);
  };

  const handleCancelClick = () => {
    setShowForm(true);
    onClose();
  };

  // Selector
  const { salesList } = useSelector((store) => ({
    salesList: store?.serviceData?.getSalesListStatus?.data?.data,
  }));

  useEffect(() => {
    dispatch(
      getSalesList({
        pageLimit: "all",
      })
    );
  }, []);

  const salesOptions = (salesList?.data || salesList)?.map((sales) => ({
    value: sales.id,
    label: sales.unique_id,
  }));

  const handleConfirm = () => {
    setIsLoading(true);

    const payload = {
      id: existingData,
      service_quotation_id: selectedOption === "existingQuotation" ? 2 : 1,
      sales_id:
        selectedOption === "existingQuotation" ? selectedType?.value : "",
    };

    dispatch(addQuotation(payload))
      .then((res) => {
        if (res.type === "addQuotation/fulfilled") {
          onClose();
          dispatch(getServiceById(existingData));
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className="model" style={{ zIndex: 1300 }}>
        <div className="flex flex-col items-center justify-center">
          <div className="bg-white drop-shadow-lg rounded-lg w-[600px] py-8 px-6 mx-auto relative">
            <div className="flex justify-center">
              <h2 className="text-3xl font-normal font-Montserrat text-center mb-6 w-[52%]">
                Add to Existing System Quotation?
              </h2>
            </div>
            <div className="space-y-4">
              <div className="flex items-center">
                <RadioButton
                  idFrom="new"
                  name="quotation"
                  label="Create New System Quotation"
                  className="text-base text-left font-normal font-Proxima"
                  onChange={() => setSelectedOption("newQuotation")}
                />
              </div>
              <div className="flex items-center">
                <RadioButton
                  idFrom="existingQuotation"
                  name="quotation"
                  label="Merged to Existing System Quotation"
                  className="text-base font-normal font-Proxima"
                  defaultChecked
                  onChange={() => setSelectedOption("existingQuotation")}
                />
              </div>
              {selectedOption === "existingQuotation" && (
                <SelectWithLabel
                  idFromName="option"
                  placeholder="Select System Quotation"
                  options={salesOptions}
                  value={selectedType}
                  errors={error}
                  touched={error}
                  onChange={(event) => {
                    const selectedOption = salesOptions.find(
                      (option) => option.value === event.target.value
                    );
                    setSelectedType(selectedOption);
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        zIndex: 1301,
                        maxHeight: "300px",
                        overflowY: "auto",
                      },
                    },
                  }}
                  renderValue={(selected) =>
                    selected ? selected.label : "Select System Quotation"
                  }
                />
              )}
            </div>
            <div className="flex justify-center gap-3 pt-7">
              <button
                type="button"
                className="text-themeBtn flex items-center uppercase  justify-center px-6 py-1.5 rounded border border-themeBtn w-full font-Proxima"
                onClick={handleCancelClick}
              >
                <span>Cancel</span>
              </button>
              <button
                type="button"
                className={`flex items-center justify-center px-6 py-1.5 rounded font-Proxima uppercase ${
                  isLoading
                    ? "bg-disableThemeBtn w-full"
                    : "border-2 border-themeBtn rounded text-white bg-themeBtn w-full"
                }`}
                disabled={isLoading}
                onClick={handleAddClick}
              >
                Add
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Confirmation Modal */}
      {!showForm && (
        <ConfirmationModel
          width="w-[425px]"
          fontSize="text-[20px]"
          confirmText={
            selectedOption === "existingQuotation"
              ? " Merge with System Quotation"
              : "Pushed to Sales As a New System Quotation"
          }
          subText={
            selectedOption === "existingQuotation"
              ? `"#${selectedType?.label}"`
              : ""
          }
          onConfirm={handleConfirm}
          onClose={() => {
            setShowForm(true);
          }}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default ExistingQuotationModal;
